/**
 * Constantes frontend pour les statuts de réservations
 * Synchronisées avec backend/constants/enums.js
 */

export const RESERVATION_STATUSES = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  ACTIVE: 'active',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
  EXPIRED: 'expired',
  PAYMENT_FAILED: 'payment_failed'
};

// Configuration d'affichage pour chaque statut
export const RESERVATION_STATUS_CONFIG = {
  [RESERVATION_STATUSES.PENDING]: {
    label: 'En attente',
    color: '#ff9800',
    bgColor: 'rgba(255, 152, 0, 0.1)',
    icon: '⏳'
  },
  [RESERVATION_STATUSES.CONFIRMED]: {
    label: 'Confirmée',
    color: '#2196f3',
    bgColor: 'rgba(33, 150, 243, 0.1)',
    icon: '✅'
  },
  [RESERVATION_STATUSES.ACTIVE]: {
    label: 'Active',
    color: '#4caf50',
    bgColor: 'rgba(76, 175, 80, 0.1)',
    icon: '🔄'
  },
  [RESERVATION_STATUSES.COMPLETED]: {
    label: 'Terminée',
    color: '#8bc34a',
    bgColor: 'rgba(139, 195, 74, 0.1)',
    icon: '🎉'
  },
  [RESERVATION_STATUSES.CANCELLED]: {
    label: 'Annulée',
    color: '#f44336',
    bgColor: 'rgba(244, 67, 54, 0.1)',
    icon: '❌'
  },
  [RESERVATION_STATUSES.REFUNDED]: {
    label: 'Remboursée',
    color: '#9c27b0',
    bgColor: 'rgba(156, 39, 176, 0.1)',
    icon: '💰'
  },
  [RESERVATION_STATUSES.EXPIRED]: {
    label: 'Expirée',
    color: '#795548',
    bgColor: 'rgba(121, 85, 72, 0.1)',
    icon: '⏰'
  },
  [RESERVATION_STATUSES.PAYMENT_FAILED]: {
    label: 'Paiement échoué',
    color: '#e91e63',
    bgColor: 'rgba(233, 30, 99, 0.1)',
    icon: '💳'
  }
};